<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>城市管理</el-breadcrumb-item>
      <el-breadcrumb-item>城市列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="9">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
              style="width:300px;"
            @clear="getChengshiList"
            @change="getChengshiList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getChengshiList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialog">添加城市</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="chengshiList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="chengshi_bianhao" label="编号" ></el-table-column>
            <el-table-column prop="chengshi_name" label="名称" ></el-table-column>
            <el-table-column prop="chengshi_mob" label="手机"></el-table-column>
            <el-table-column prop="chengshi_admin" label="管理人"></el-table-column>
            <el-table-column prop="chengshi_password" label="密码"></el-table-column>
            <el-table-column prop="yong_flag" label="状态">
              <template v-slot="scope">
                <el-switch v-model="scope.row.yong_flag"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="showEditDialog(scope.row.uid)"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>

              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加城市部分 -->
      <el-dialog title="添加城市" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">

          <el-form-item label="城市编号" prop="chengshi_bianhao">
            <el-input v-model="addForm.chengshi_bianhao" :disabled="true"> </el-input>
          </el-form-item>

          <el-form-item label="城市名称" prop="chengshi_name">
            <el-input v-model="addForm.chengshi_name"></el-input>
          </el-form-item>

          <el-form-item label="城市管理人" prop="chengshi_admin">
            <el-input v-model="addForm.chengshi_admin"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="chengshi_mob">
            <el-input v-model="addForm.chengshi_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addChengshi" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改城市信息 -->
      <el-dialog
        title="修改城市信息"
        :visible.sync="editDialogVisible"
        width="50%"
        @close="editDoalogClosed"
      >
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="城市编号" prop="chengshi_uid">
            <el-input v-model="editForm.chengshi_uid" :disabled="true"> </el-input>
          </el-form-item>
          <el-form-item label="城市编号" prop="chengshi_bianhao">
            <el-input v-model="editForm.chengshi_bianhao" :disabled="true"> </el-input>
          </el-form-item>

          <el-form-item label="城市名称" prop="chengshi_name">
            <el-input v-model="editForm.chengshi_name"></el-input>
          </el-form-item>

          <el-form-item label="城市管理人" prop="chengshi_admin">
            <el-input v-model="editForm.chengshi_admin"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="chengshi_mob">
            <el-input v-model="editForm.chengshi_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateChengshi" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
  import { checkMobileTest } from '../../tongyong/config/validator'
export default {
  data() {
    // var checkMobile = (rule, value, cb) => {
    //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    // if (regMobil.test(value)) {
    //    return cb()
    //  }
    //  cb(new Error('请输入合法的手机号!'))
    //  }
    return {
      // 获取用户列表参数
      queryInfo: {
      //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'chengshi_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      add_isDisable: false,
      chengshiList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      //  添加表单数据项
      addForm: {
        C_type: 'chengshi_add',
        chengshi_bianhao: '',
        chengshi_name: '',
        chengshi_admin: '',
        chengshi_mob: ''
      },
      // 用于修改数据绑定
      editForm: {},
    // 表单规则项
      addFormRules: {
        chengshi_name: [
          { required: true, message: '请输入城市名称', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符 ', trigger: 'blur' }
        ],
        chengshi_admin: [
          { required: true, message: '请输入城市管理员', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符', trigger: 'blur' }
        ],
        chengshi_mob: [
         { validator: checkMobileTest.bind(this.addForm && this.addForm.chengshi_mob) }

        ]
      }
    };
  },
  created() {
    this.getChengshiList();
  },
  methods: {
    async getChengshiList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
            // console.log(JSON.parse(res.data))
      this.chengshiList = JSON.parse(res.data)[0].dataList

       if (!this.chengshiList) return
      this.chengshiList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
     this.getChengshiList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getChengshiList();
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 远程获取编号，并写入表单
     async addDialog() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 5 }
      });
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.chengshi_bianhao = JSON.parse(res.data)[0].bianhao_s;
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true
    },
    addChengshi() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
          setTimeout(() => {
           this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
       }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return
        }
        this.$message.success('添加成功');
        this.getChengshiList();
        this.addDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.editDialogVisible = true;
      this.chengshiInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async chengshiInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'chengshi_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
    },
     updateChengshi() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return this.$message.error('验证错误！');
        const { data: res } = await this.$http.post('api', {
          C_type: 'chengshi_update',
          chengshi_uid: this.editForm.chengshi_uid,
          chengshi_bianhao: this.editForm.chengshi_bianhao,
          chengshi_name: this.editForm.chengshi_name,
          chengshi_admin: this.editForm.chengshi_admin,
          chengshi_mob: this.editForm.chengshi_mob
        });

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getChengshiList();
        this.editDialogVisible = false;
      });
    },
    // 删除一条记录
    async  deleteForm(chengshiUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
           const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)
        console.log(comfirmResult)
        if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
        const { data: res } = await this.$http.post('api', {
          C_type: 'record_delete',
          C_table_name: 'chengshi_del',
          C_data1: chengshiUid

        });
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('删除失败');
          return;
        }
        this.$message.success('删除成功');
        this.getChengshiList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}
.el_row_two {
  margin-top: 30px;
}
</style>
